/**
 * Functions to open and Close the Flyout
 */

const filterFlyout = document.getElementById('filter-flyout');
const filterFlyoutContent = document.getElementById('filter-flyout__selection');
const filterFlyoutItems = document.getElementsByClassName('filter-flyout__selection__content');

/**
 * Open the Flyout
 * @param {Event} e
 * @returns {Function}
 */
export const handleFlyoutOpen = (e) => {
    const contentSelector = `[data-filterKey="${e.target.dataset.target}"]`;
    filterFlyout.classList.add('filter__flyout--visible');
    filterFlyoutContent.classList.add('filter-flyout__selection--visible');
    document.querySelector(contentSelector).classList.add('filter-flyout__selection__content--visible');
    document.body.style.overflowY = 'hidden';
};

/**
 * Close the Flyout
 * @returns {Function}
 */
export const handleFlyoutClose = () => {
    Array.from(filterFlyoutItems).forEach(item => {
        item.classList.remove('filter-flyout__selection__content--visible');
    });
    filterFlyout.classList.remove('filter__flyout--visible');
    filterFlyoutContent.classList.remove('filter-flyout__selection--visible');
    document.body.style.overflowY = 'auto';
};



// WEBPACK FOOTER //
// ./src/scripts/components/filter-flyout/handleFlyout.js